import * as React from "react";

export const IconNotification = ({ hasDot, ...rest }: React.SVGProps<SVGSVGElement> & { hasDot?: boolean }): React.JSX.Element => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...rest}>
      {hasDot ? (
        <>
          <path
            d="M18 3.5C18.7022 3.5 19.283 3.74002 19.7715 4.22852C20.26 4.71702 20.5 5.29776 20.5 6C20.5 6.70224 20.26 7.28298 19.7715 7.77148C19.283 8.25998 18.7022 8.5 18 8.5C17.2978 8.5 16.717 8.25998 16.2285 7.77148C15.74 7.28298 15.5 6.70224 15.5 6C15.5 5.29776 15.74 4.71702 16.2285 4.22852C16.717 3.74002 17.2978 3.5 18 3.5Z"
            fill="#D32F2F"
            stroke="white"
          />
          <path
            d="M12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22ZM4 19V17H6V10C6 8.61667 6.41667 7.3875 7.25 6.3125C8.08333 5.2375 9.16667 4.53333 10.5 4.2V3.5C10.5 3.08333 10.6458 2.72917 10.9375 2.4375C11.2292 2.14583 11.5833 2 12 2C12.4167 2 12.7708 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5V3.825C13.3167 4.19167 13.1833 4.56667 13.1 4.95C13.0167 5.33333 12.9833 5.725 13 6.125C12.8333 6.09167 12.6708 6.0625 12.5125 6.0375C12.3542 6.0125 12.1833 6 12 6C10.9 6 9.95833 6.39167 9.175 7.175C8.39167 7.95833 8 8.9 8 10V17H16V10.575C16.3 10.7083 16.6208 10.8125 16.9625 10.8875C17.3042 10.9625 17.65 11 18 11V17H20V19H4Z"
            fill="white"
          />
        </>
      ) : (
        <g clip-path="url(#clip0_30099_106892)">
          <path
            d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z"
            fill="white"
          />
        </g>
      )}
    </svg>
  );
};
